export const endpoints = {
  DASHBOARD_VIEW: '/dashboard/view',
  DASHBOARD_CREATE: '/dashboard/create',
  DASHBOARD_UPDATE: '/dashboard/update',
  DASHBOARD_DELETE: '/dashboard/delete',
  CHART_VIEW: '/chart/view',
  CHART_CREATE: '/chart/create',
  CHART_UPDATE: '/chart/update',
  CHART_DELETE: '/chart/delete'
}